import React, { RefObject } from 'react';
import RecapCommande from '../../components/organisms/RecapCommande';
import { Enum_Commande_Status } from '../../graphql/generated/graphql';
import PaymentForm from '../../components/organisms/forms/Sherlocks/PaymentForm';
import { PublicShopCommande } from '../../types/commande/commande.def';
import { ButtonWithText } from '../../components/atoms/Buttons/ButtonWithText';
import { FeatureContainer } from '../../components/molecules/Containers/FeatureContainer';

interface PublicShopRecapCommandeViewProps {
  recapCommande: PublicShopCommande;
}

const PublicShopRecapCommandeView = ({
  recapCommande
}: PublicShopRecapCommandeViewProps) => {
  const payForm: RefObject<HTMLFormElement> = React.createRef();

  if (!recapCommande)
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '60vh'
        }}
      >
        <h2>
          {' '}
          Aucune commande à afficher{' '}
          <span role="img" aria-label="emojis déçu">
            😕
          </span>
        </h2>
      </div>
    );
  const { sherlock, commande } = recapCommande;

  if (commande.status === Enum_Commande_Status.Annule)
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '60vh'
        }}
      >
        <h2>
          La commande a été annulée{' '}
          <span role="img" aria-label="emojis déçu">
            😕
          </span>
        </h2>
      </div>
    );

  const isPaye = commande.status === Enum_Commande_Status.Paye;
  const title = isPaye
    ? 'Paiement effectué avec succès ! 🎉'
    : "Votre commande n'est pas encore payée 😕";

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
      <FeatureContainer>
        <h2 style={{ margin: 'auto' }}>{title}</h2>
        {!isPaye && commande.statuspayment && (
          <p style={{ margin: 'auto' }}>
            Statut de votre dernière tentative de paiement :{' '}
            {commande.statuspayment}
          </p>
        )}
        {isPaye && (
          <>
            <p style={{ margin: 'auto' }}>
              Numéro de transaction : {commande.transactionreference}
            </p>
            <p style={{ margin: 'auto' }}>
              NB: Vous recevrez votre facture lors de la livraison.
            </p>
          </>
        )}
        {!isPaye && sherlock && (
          <div style={{ margin: 'auto', padding: '10px' }}>
            <ButtonWithText
              content={'Finaliser votre commande'}
              onClick={() => payForm.current.submit()}
              variant={'danger'}
            />
            <PaymentForm sherlock={sherlock} ref={payForm} />
          </div>
        )}
      </FeatureContainer>
      <RecapCommande commande={commande} />
    </div>
  );
};
export default PublicShopRecapCommandeView;
